import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { PlanType } from '../../utils/enums/plan-type.enum';
import { PaymentProcessingStatus } from '../../utils/enums/payment-processing-status.enum';

export interface IMetaData {
  title: string;
  content: string[];
}

export interface IProduct {
  order?: string;
  subscriptionId?: string;
  name: PlanType;
  metadata?: { [key: string]: string | number };
  baseValue: number;
}

export interface ISubscriptionSlice {
  componentStatus: { [name: string]: undefined | string | boolean };
  products: IProduct[];
  productDetails: IProduct | undefined;
  clientSecret: string | null;
  organizationSubscription: string | null;
  paymentProcessing: PaymentProcessingStatus;
  paymentError: string | null;
}

const initialState: ISubscriptionSlice = {
  componentStatus: {},
  products: [],
  productDetails: undefined,
  clientSecret: null,
  organizationSubscription: null,
  paymentProcessing: PaymentProcessingStatus.IDLE,
  paymentError: null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setComponentStatus(
      state: ISubscriptionSlice,
      action: PayloadAction<{ [key: string]: undefined | string | boolean }>,
    ) {
      state.componentStatus = { ...state.componentStatus, ...action.payload };
    },
    clearComponentStatus(state: ISubscriptionSlice, action: PayloadAction<string[] | undefined>) {
      if (action.payload?.length) {
        state.componentStatus = _.omit(state.componentStatus, action.payload);
      } else {
        state.componentStatus = {};
      }
    },
    getProductsAsync(_state: ISubscriptionSlice, _action: PayloadAction) {},
    setProducts(state: ISubscriptionSlice, action: PayloadAction<IProduct[]>) {
      state.products = action.payload;
    },
    getProductByIdAsync(_state: ISubscriptionSlice, _action: PayloadAction<string>) {},
    setProductDetails(state: ISubscriptionSlice, action: PayloadAction<IProduct>) {
      state.productDetails = action.payload;
    },
    setClientSecret(state, action: PayloadAction<string>) {
      state.clientSecret = action.payload;
    },

    fetchSetupIntentSecretAsync(_state, _action: PayloadAction<{ customerId: string }>) {},
    fetchPaymentIntentSecretAsync(_state, _action: PayloadAction<{ customerId: string; amount: number }>) {},
    processPaymentAsync(_state, _action: PayloadAction<void>) {},
    setPaymentProcessing(state, action: PayloadAction<PaymentProcessingStatus>) {
      state.paymentProcessing = action.payload;
    },
    setPaymentError(state, action: PayloadAction<string | null>) {
      state.paymentError = action.payload;
    },
    confirmPaymentAndUnlockAsync: (_state, _action: PayloadAction<{ paymentIntentId: string }>) => {},
  },
});

export const { actions: subscriptionActions, reducer: subscriptionReducer } = subscriptionSlice;
